
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1004"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1004",
    "ar-eg": "static-7.1004",
    "bg": "static-7.1004",
    "bn": "static-7.1004",
    "ca-es": "static-7.1004",
    "cs": "static-7.1004",
    "da": "static-7.1004",
    "de": "static-7.1004",
    "el": "static-7.1004",
    "en-gb": "static-7.1004",
    "en": "static-7.1004",
    "es-mx": "static-7.1004",
    "es": "static-7.1004",
    "fi": "static-7.1004",
    "fr-ca": "static-7.1004",
    "fr": "static-7.1004",
    "he-il": "static-7.1004",
    "hr": "static-7.1004",
    "hu": "static-7.1004",
    "id": "static-7.1004",
    "it": "static-7.1004",
    "ja": "static-7.1004",
    "ko": "static-7.1004",
    "lt": "static-7.1004",
    "ms": "static-7.1004",
    "nl": "static-7.1004",
    "no": "static-7.1004",
    "pl": "static-7.1004",
    "pt-br": "static-7.1004",
    "pt-pt": "static-7.1004",
    "ro": "static-7.1004",
    "ru": "static-7.1004",
    "sk": "static-7.1004",
    "sl": "static-7.1004",
    "sv": "static-7.1004",
    "th": "static-7.1004",
    "tl": "static-7.1004",
    "tr": "static-7.1004",
    "uk": "static-7.1004",
    "vi": "static-7.1004",
    "x-pseudo": "static-7.1004",
    "zh-cn": "static-7.1004",
    "zh-hk": "static-7.1004",
    "zh-tw": "static-7.1004"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1004'}); }
})();


